import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { request } from '../../services/api';
import { CircuitBackgroundLayer } from "../../components/CircuitBackground/AnimatedCircuitChipBackground";
import {
    FaThermometerHalf, FaTint, FaWind, FaArrowLeft, FaRss, FaPhoneAlt,
    FaCogs, FaLightbulb, FaRedo, FaPowerOff, FaPlug, FaShieldAlt,
    FaToggleOn  
} from "react-icons/fa";
import styles from './Monitor.module.css';
import DigitalOutputCard from './DigitalOutputCard';
import SecurityCard from './SecurityCard';
import GsmControlCard from './GsmControlCard';
import RemoteControlCard from './RemoteControlCard';
import { useMonitorSocket } from '../../hooks/useMonitorSocket';
import SensorGrid from './SensorGrid';
import DigitalInputCard from './DigitalInputCard';
import SensorControlCard from './SensorControlCard';

// --- ایمپورت کامپوننت جدید ---
import ExpandableTile from '../../components/common/ExpandableTile';

const MonitorPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    
    const [customNames, setCustomNames] = useState({
    dIn: {},
    dOut: {},
    temp: {},
    humi: {}
});
    // لود نام‌های سفارشی از سرور
 useEffect(() => {
    const loadAllCustomNames = async () => {
        try {
            const [dIn, dOut, temp, humi, wind] = await Promise.all([
                request(`/manage_input_names.php?device_id=${id}&input_type=dIn`),
                request(`/manage_input_names.php?device_id=${id}&input_type=dOut`),
                request(`/manage_input_names.php?device_id=${id}&input_type=temp`),
                request(`/manage_input_names.php?device_id=${id}&input_type=humi`),
                request(`/manage_input_names.php?device_id=${id}&input_type=wind`)
            ]);
            
            setCustomNames({
                dIn: dIn || {},
                dOut: dOut || {},
                temp: temp || {},
                humi: humi || {},
                wind: wind || {}
            });
        } catch (error) {
            console.error('Error loading custom names:', error);
        }
    };
    loadAllCustomNames();
}, [id]);
// --- ۳. اصلاح تابع ذخیره‌سازی با پارامتر نوع (Type) ---
const handleSaveCustomName = async (type, index, newName) => {
    try {
        await request('/manage_input_names.php', 'POST', {
            device_id: id,
            input_type: type, // dIn یا dOut
            input_index: index,
            customName: newName
        });

        // به‌روزرسانی محلی State
        setCustomNames(prev => ({
            ...prev,
            [type]: {
                ...prev[type],
                [index]: newName
            }
        }));
    } catch (error) {
        console.error('Error saving custom name:', error);
    }
};
    const {
        device,
        sensorData,
        wsConnected,
        suspendedSensors,
        sendCommand,
        handleRetryAll
    } = useMonitorSocket(id);

    if (!device) return <div className={styles.container}><div style={{textAlign:'center', paddingTop: 100}}>در حال بارگذاری...</div></div>;

    return (
        <div className={styles.container}>
            <CircuitBackgroundLayer />
            <div className={styles.overlay}></div>
            <div className={styles.content}>
                {/* --- هدر --- */}
                <div className={styles.header}>
                    <div className={styles.deviceTitle}>
                         <span style={{fontSize:'2rem'}}>🏭</span>
                         <div>
                             <div style={{fontWeight:'bold'}}>{device.device_name}</div>
                             <span style={{fontSize: '12px', color: '#ccc', fontFamily:'arial'}}>{device.device_serial}</span>
                         </div>
                    </div>
                    <div style={{display:'flex', alignItems:'center', gap:'15px'}}>
                        {suspendedSensors.size > 0 && (
                            <button onClick={handleRetryAll} className={styles.retryBtn}>
                                <FaRedo /> بازیابی ({suspendedSensors.size})
                            </button>
                        )}
                        <div className={wsConnected ? styles.badgeOnline : styles.badgeOffline}>
                            {wsConnected ? '● آنلاین' : '● آفلاین'}
                        </div>
                        <button onClick={() => navigate('/dashboard')} className={styles.backBtn}>
                            <FaArrowLeft /> بازگشت
                        </button>
                    </div>
                </div>

                {/* --- گرید کاشی‌ها --- */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)', // ۴ ستون مساوی
                    gap: '20px',
                    width: '100%',
                    paddingBottom: '50px'
                }}>
                    {/* کاشی ۱: ورودی‌های دیجیتال */}
                    <ExpandableTile title="ورودی‌های دیجیتال" icon={<FaPowerOff color="#f6ad55" />}>
                     <SensorGrid
    type="dIn" 
    count={68} 
    label="ورودی" 
    icon={<FaPowerOff color="#f6ad55" />} 
    unit=""
    sensorData={sensorData} 
    suspendedSensors={suspendedSensors} 
    onUpdate={sendCommand}
    CardComponent={DigitalInputCard}
    // اصلاح این دو خط:
    customNames={customNames.dIn}
    onSaveCustomName={(index, name) => handleSaveCustomName('dIn', index, name)}
/>
                    </ExpandableTile>

                    {/* کاشی ۲: کنترل خروجی‌ها */}
                   <ExpandableTile title="کنترل خروجی‌ها" icon={<FaPowerOff color="#39ff14" />}>
    <SensorGrid
        type="dOut" 
        count={72} 
        label="خروجی" 
        icon={<FaPowerOff color="#39ff14" />} 
        unit=""
        sensorData={sensorData} 
        suspendedSensors={suspendedSensors} 
        onUpdate={sendCommand}
        CardComponent={DigitalOutputCard}
        // اضافه کردن این دو خط برای خروجی‌ها:
        customNames={customNames.dOut}
        onSaveCustomName={(index, name) => handleSaveCustomName('dOut', index, name)}
    />
</ExpandableTile>

 {/* کنترل دما */}
<ExpandableTile title="کنترل دما" icon={<FaThermometerHalf color="#ff6b6b" />}>
    <SensorGrid
        type="temp"
        count={9}
        label="دما"
        icon={<FaThermometerHalf color="#ff6b6b" />}
        unit="°C"
        sensorData={sensorData}
        suspendedSensors={suspendedSensors}
        onUpdate={sendCommand}
        CardComponent={SensorControlCard}
        customNames={customNames.temp}
        onSaveCustomName={(index, name) => handleSaveCustomName('temp', index, name)}
        serial={device.device_serial}
        token={token}
    />
</ExpandableTile>

{/* کنترل رطوبت */}
<ExpandableTile title="کنترل رطوبت" icon={<FaTint color="#4dabf7" />}>
    <SensorGrid
        type="humi"
        count={9}
        label="رطوبت"
        icon={<FaTint color="#4dabf7" />}
        unit="%"
        sensorData={sensorData}
        suspendedSensors={suspendedSensors}
        onUpdate={sendCommand}
        CardComponent={SensorControlCard}
        customNames={customNames.humi}
        onSaveCustomName={(index, name) => handleSaveCustomName('humi', index, name)}
        serial={device.device_serial}
        token={token}
    />
</ExpandableTile>

{/* سنجش باد */}
<ExpandableTile title="سنجش باد" icon={<FaWind color="#cbd5e0" />}>
    <SensorGrid
        type="wind"
        count={1}
        label="سنسور باد"
        icon={<FaWind color="#cbd5e0" />}
        unit="km/h"
        sensorData={sensorData}
        suspendedSensors={suspendedSensors}
        onUpdate={sendCommand}
        CardComponent={SensorControlCard}
        customNames={customNames.wind}
        onSaveCustomName={(index, name) => handleSaveCustomName('wind', index, name)}
        serial={device.device_serial}
        token={token}
    />
</ExpandableTile>

                    {/* کاشی ۶: امنیت و حفاظت */}
                    <ExpandableTile title="امنیت و حفاظت" icon={<FaShieldAlt color="#e74c3c" />}>
                        <div className={styles.sensorsGrid}>
                            {sensorData['secu0'] && (
                                <SecurityCard
                                    data={sensorData['secu0']}
                                    onUpdate={(prop, val) => sendCommand('secu', 0, prop, val)}
                                />
                            )}
                        </div>
                    </ExpandableTile>

                    {/* کاشی ۷: تنظیمات GSM */}
                    <ExpandableTile title="تنظیمات GSM" icon={<FaPhoneAlt color="#3498db" />}>
                        <div className={styles.sensorsGrid}>
                            <GsmControlCard
                                data={sensorData['gsm0']}
                                onUpdate={(prop, val) => sendCommand('gsm', 0, prop, val)}
                            />
                        </div>
                    </ExpandableTile>

                    {/* کاشی ۸: ریموت کنترل */}
                    <ExpandableTile title="ریموت کنترل" icon={<FaRss color="#9b59b6" />}>
                        <div className={styles.sensorsGrid}>
                            <RemoteControlCard
                                data={sensorData['remote0']}
                                onUpdate={(prop, val) => sendCommand('remote', 0, prop, val)}
                            />
                        </div>
                    </ExpandableTile>

                </div>
            </div>
        </div>
    );
};

export default MonitorPage;